var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "comment" },
    [
      _c("div", { staticClass: "user_label text-center px-0" }, [
        _vm._v(_vm._s(_vm.userNameShort))
      ]),
      _vm._v(" "),
      _c("b", [
        _vm._v(
          _vm._s(
            _vm.comment.aspNetUser &&
              _vm.comment.aspNetUser.firstName +
                " " +
                _vm.comment.aspNetUser.lastName
          )
        )
      ]),
      _c("br"),
      _vm._v(" "),
      _vm.readonly || _vm.editComment === null
        ? [
            _c("code", { staticClass: "comment_textarea col-12" }, [
              _vm._v(_vm._s(_vm.comment.text))
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "comment_links" },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.formatDateTime(_vm.comment.createdOn)) +
                    "\n            "
                ),
                !_vm.readonly
                  ? [
                      _vm.userId === _vm.comment.aspNetUserId
                        ? [
                            _vm._v(
                              "\n                    -\n                    "
                            ),
                            _c(
                              "a",
                              {
                                attrs: { href: "#" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    _vm.editComment = _vm.comment.text
                                    _vm.$nextTick(() =>
                                      _vm.$refs.editbox.focus()
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.$t("btnEdit")) +
                                    "\n                    "
                                )
                              ]
                            ),
                            _vm._v(
                              "\n                    -\n                    "
                            ),
                            _c(
                              "a",
                              {
                                attrs: { href: "#" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.deleteComment.apply(
                                      null,
                                      arguments
                                    )
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("btnDelete")))]
                            )
                          ]
                        : [
                            _vm._v(
                              "\n                    -\n                    "
                            ),
                            _c(
                              "a",
                              {
                                attrs: { href: "#" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.reply.apply(null, arguments)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("btnReply")))]
                            )
                          ]
                    ]
                  : _vm._e()
              ],
              2
            )
          ]
        : [
            _c("div", { staticClass: "d-flex" }, [
              _c(
                "div",
                { staticClass: "mr-1", staticStyle: { flex: "1 1 auto" } },
                [
                  _c("textarea", {
                    directives: [
                      { name: "autogrow", rawName: "v-autogrow" },
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.editComment,
                        expression: "editComment"
                      }
                    ],
                    ref: "editbox",
                    staticClass: "form-control add_comment mb-1",
                    staticStyle: { "overflow-y": "hidden" },
                    attrs: {
                      id: "commenteditbox_" + _vm.comment.id,
                      rows: "1",
                      placeholder: _vm.$t("txtAddComment")
                    },
                    domProps: { value: _vm.editComment },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) return
                        _vm.editComment = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("text-suggest", {
                    attrs: {
                      textBoxId: "commenteditbox_" + _vm.comment.id,
                      suggestions: _vm.userEmails,
                      trigger: "@"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ml-1", staticStyle: { flex: "0 0 auto" } },
                [
                  _c("div", { staticClass: "mb-1" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary w-100",
                        attrs: { type: "button" },
                        on: { click: _vm.save }
                      },
                      [_vm._v(_vm._s(_vm.$t("btnSave")))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary w-100",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.editComment = null
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("btnCancel")) +
                            "\n                    "
                        )
                      ]
                    )
                  ])
                ]
              )
            ])
          ],
      _vm._v(" "),
      _vm.newReply
        ? [
            _c("reply", {
              attrs: {
                reply: _vm.newReply,
                openAsEdit: true,
                userEmails: _vm.userEmails
              },
              on: {
                "reply-save": _vm.newReplySave,
                "reply-cancel": function($event) {
                  _vm.newReply = null
                }
              }
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "reply_comment_area margin_top_10" },
        _vm._l(_vm.comment.commentReplies, function(reply) {
          return _c("reply", {
            key: reply.id,
            attrs: {
              reply: reply,
              readonly: _vm.readonly,
              lockeddown: _vm.lockeddown,
              userEmails: _vm.userEmails
            },
            on: { "reply-delete": _vm.replyDelete, "reply-save": _vm.replySave }
          })
        }),
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }